import { vMaska } from 'maska/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App/App.vue'
import globalComponents from './plugins/globalComponents'
import router from './router'
import '@/plugins/axios'
import PrimeVue from 'primevue/config'
// import clickOutside from './directives/clickOutside';

const app = createApp(App)
// app.directive('click-outside', clickOutside)

globalComponents(app)

app.use(createPinia())
app.directive('maska', vMaska)
app.use(router)
app.use(PrimeVue)

app.mount('#app')
